import { FC, ReactNode } from 'react';
import classNames from 'classnames';

interface Props {
  children: ReactNode;
  className?: string;
}

// A small section heading shown in capitals (e.g. "PRIVATE"), just the
// label with no divider lines. Pass normal-case text; CSS does the capitals,
// so translations stay readable in the catalogues.
const SectionLabel: FC<Props> = ({ children, className }) => (
  <p className={classNames(styles.base, className)}>{children}</p>
);

export default SectionLabel;

const styles = {
  base: 'py-1 text-[10px] font-semibold uppercase tracking-widest text-ink-secondary',
};
